import React, { useEffect, useLayoutEffect, useState } from "react";
import "./CaseHistory.scss";
import _ from "lodash";
import { utilService } from "../../services";

import Loader from "../../components/Shared/Loader/Loader";
import { IonCol, IonGrid, IonIcon, IonRow, IonSearchbar } from "@ionic/react";
import { Link } from "react-router-dom";
import { loggedInUserService } from "../../services/loggedInUser.service";
import { CaseHistoryService } from "./CaseHistory.service";
import CaseHistoryMessageListCard from "../../components/Shared/CaseHistoryListCard/caseHistoryListCard";
import CaseHistoryDetailsView from "./CaseHistoryDetailView/CaseHistoryDetailView";
import { addCircle, chevronBackOutline } from "ionicons/icons";
import { CONSTANTS } from "../../constants/callcentral.constants";
import { dataTransferService } from "../../services/dataTransferService";
import SortByEMSDropDown from "./SortByEMSDropDown/SortByEMSDropDown";
import { useLocation } from "react-router";
import { useTranslation } from "react-i18next";


interface CaseHistoryProps {
  isFromEMTHome: boolean;
}

const CaseHistoryComponent: React.FC<CaseHistoryProps> = (props) => {
  const [CaseHistoryListData, setCaseHistoryListData]: any = useState([]);
  const [inPatientCaseHistory, setInPatientCaseHistory]: any = useState([]);
  const [outPatientCaseHistory, setOutPatientCaseHistory]: any = useState();
  const [caseHistoryData, setCaseHistoryData]: any = useState([]);
  const [fetchedcaseHistoryData, setFetchedcaseHistoryData]: any = useState([]);
  const [isCaseHistorySelected, setCaseHistorySelection]: any = useState(false);
  const [searchText, setSearchText] = useState("");
  const [isEMTUser, checkEMTUser]: any = useState(false);
  const [selectedPatient, setSelectedPatient]: any = useState();
  const [inPatientBtnClicked, setInPatientBtnClicked]: any = useState(false);
  const [outPatientBtnClicked, setOutPatientBtnClicked]: any = useState(false);
  const [caseUpdates, setCaseUpdates]: any = useState(false);
  const [showLoader, setShowLoader]: [boolean, Function] = useState(false);
  const [isLoaderActive, setLoaderStatus] = useState(false);
  const { t } = useTranslation("ems");
  const location: any = useLocation();

  const [isIpad, setIsIpad] = useState(false);

  const handleResize = () => {
    setIsIpad(
      window.innerWidth >= 768 &&
        window.innerWidth <= 1024 &&
        window.innerHeight > window.innerWidth
    );
  };

  useEffect(() => {
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const subscription = getLoggedInUserData();
    setCaseHistorySelection(false);
    // getCaseHistoryList();
    return () => subscription.unsubscribe();
  }, []);

  useEffect(() => {
    getDeidentificationForCaseHistory();
    // The interval was never cleared: it kept polling after the user left the
    // page, and every return to Case History started another one on top.
    const interval = setInterval(() => {
      getDeidentificationForCaseHistory();
    }, 45000);
    return () => clearInterval(interval);
  }, []);

  async function getDeidentificationForCaseHistory() {
    let params = {
      reg_code: utilService.getNetwork(),
    };
    const respTransferPatientResult: any =
      await CaseHistoryService.getDeIdentificationDetails(params);
    if (respTransferPatientResult.isSuccess) {
      // getPatientHistoryList("active");
    }
  }
  // Returns the subscription so the caller can tear it down; it used to be
  // dropped on the floor, leaving a live handler behind on every mount.
  const getLoggedInUserData = () => {
    return loggedInUserService.loggedInUserData.subscribe((data: any) => {
      let isEmtUser = checkIsEMTUser(data.userData);
      checkEMTUser(isEmtUser);
    });
  };

  const checkIsEMTUser = (loggedInUser: any): any => {
    if (loggedInUser) {
      return loggedInUser.roles.some(function (item: any) {
        return item.name === CONSTANTS.ROLES.EMT;
      });
    }
  };

  useLayoutEffect(() => {
    let sub = dataTransferService.getUpdateCaseDetails.subscribe(
      (data: any) => {
        if (data === true) {
          setCaseUpdates(true);
        } else {
        }
      }
    );
    return () => {
      sub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(location.state)) {
      const currentLocation: any = location;
      if (currentLocation.state.inPatient) {
        setInPatientBtnClicked(true);
        onInPatientBtnClicked();
      }
    }
  }, [location]);

  useEffect(() => {
    if (searchText) {
      getPatientHistoryList("active");
    } else if (searchText === "") {
      getPatientHistoryList("active");
    }
  }, [searchText]);

  const triggerPatientList = () => {
    getPatientHistoryList("active");
  };
  useEffect(() => {
    if (inPatientBtnClicked && utilService.isWeb()) {
      if (selectedPatient) {
        handleInPatientCaseHistoryCardSelection(selectedPatient);
      } else {
        handleInPatientCaseHistoryCardSelection(inPatientCaseHistory[0]);
      }
    }
  }, [inPatientBtnClicked]);

  useEffect(() => {
    if (
      !_.isEmpty(inPatientCaseHistory) &&
      inPatientBtnClicked &&
      utilService.isWeb()
    ) {
      if (selectedPatient) {
        handleInPatientCaseHistoryCardSelection(selectedPatient);
      } else {
        handleInPatientCaseHistoryCardSelection(inPatientCaseHistory[0]);
      }
    } else if (
      !_.isEmpty(inPatientCaseHistory) &&
      inPatientBtnClicked &&
      !utilService.isWeb()
    ) {
      if (selectedPatient) {
        handleInPatientCaseHistoryCardSelection(selectedPatient);
      }
    }
  }, [inPatientCaseHistory]);

  useEffect(() => {
    if (outPatientBtnClicked && utilService.isWeb()) {
      if (selectedPatient) {
        handleOutPatientCaseHistoryCardSelection(selectedPatient);
      } else if (outPatientCaseHistory) {
        handleOutPatientCaseHistoryCardSelection(outPatientCaseHistory[0]);
      }
    }
  }, [outPatientBtnClicked]);

  useEffect(() => {
    if (
      !_.isEmpty(outPatientCaseHistory) &&
      outPatientBtnClicked &&
      utilService.isWeb()
    ) {
      if (selectedPatient) {
        handleOutPatientCaseHistoryCardSelection(selectedPatient);
      } else if (outPatientCaseHistory) {
        handleOutPatientCaseHistoryCardSelection(outPatientCaseHistory[0]);
      }
    } else if (
      !_.isEmpty(outPatientCaseHistory) &&
      outPatientBtnClicked &&
      !utilService.isWeb()
    ) {
      if (selectedPatient) {
        handleOutPatientCaseHistoryCardSelection(selectedPatient);
      }
    }
  }, [outPatientCaseHistory]);

  const handleOutPatientCaseHistoryCardSelection = (selectedCard: any) => {
    if (selectedCard) {
      setOutPatientSelectedCardList(selectedCard);
      if (utilService.isWeb()) {
        setCaseHistorySelection(false);
      } else {
        setCaseHistorySelection(true);
      }
    } else {
      setCaseHistoryData([]);
    }
  };

  const handleInPatientCaseHistoryCardSelection = (selectedCard: any) => {
    if (selectedCard) {
      setInPatientSelectedCardList(selectedCard);
      if (utilService.isWeb()) {
        setCaseHistorySelection(false);
      } else {
        setCaseHistorySelection(true);
      }
    } else {
      setCaseHistoryData([]);
    }
  };

  const setInPatientSelectedCardList = (card: any) => {
    const selectedCaseHistoryCardList: Array<any> = [];
    inPatientCaseHistory.map((item: any) => {
      if (card.id === item.id) {
        item.isSelected = true;
        selectedCaseHistoryCardList.push(card);
      } else {
        item.isSelected = false;
      }
    });
    getIncomingPatientsCaseHistory(selectedCaseHistoryCardList);
  };
  const setOutPatientSelectedCardList = (card: any) => {
    const selectedCaseHistoryCardList: Array<any> = [];
    outPatientCaseHistory.map((item: any) => {
      if (card.id === item.id) {
        item.isSelected = true;
        selectedCaseHistoryCardList.push(card);
      } else {
        item.isSelected = false;
      }
    });
    getIncomingPatientsCaseHistory(selectedCaseHistoryCardList);
  };
  async function getPatientHistoryList(caseFilterType: any) {
    setShowLoader(true);
    let params = "";
    const getPatientCaseHistoryResult: any =
      await CaseHistoryService.getPatientHistory(
        params,
        searchText,
        caseFilterType,
        isEMTUser
      );
    if (getPatientCaseHistoryResult.isSuccess) {
      setShowLoader(false);
      setInPatientCaseHistory(getPatientCaseHistoryResult.result?.[0]?.inpatients);
      setOutPatientCaseHistory(
        getPatientCaseHistoryResult.result?.[0]?.outpatients
      );

      updateOutPatientCaseDetailsSide(
        getPatientCaseHistoryResult.result?.[0]?.outpatients
      );
      updateInPatientCaseDetailsSide(
        getPatientCaseHistoryResult.result?.[0]?.inpatients
      );
    } else {
      console.log("error");
    }
  }
  // Function to get the incoming patient history details
  const getIncomingPatientsCaseHistory = async (
    selectedCaseHistory: any,
    page: number = 1
  ) => {
    setLoaderStatus(true);
    const params: any = {
      caseHistoryId: selectedCaseHistory[0]?.id,
    };
    const respSmsHistoryResult: any =
      await CaseHistoryService.getCaseHistoryDetailsList(params, isEMTUser);
    if (respSmsHistoryResult.isSuccess && respSmsHistoryResult.result) {
      setCaseHistoryData(respSmsHistoryResult.result);
      setFetchedcaseHistoryData(respSmsHistoryResult?.fetchedResult)
      setLoaderStatus(false);
    } else {
      console.log("error");
      setCaseHistoryData([]);
      setLoaderStatus(false);
    }
  };

  const getFilteredId = (selectedFilterValue: number) => {
    switch (selectedFilterValue) {
      case 0:
        getPatientHistoryList("active");
        onOutPatientBtnClicked();
        break;
      case 1:
        getPatientHistoryList("all");
        onOutPatientBtnClicked();
        break;
      case 2:
        getPatientHistoryList("archived");
        onOutPatientBtnClicked();
        setSelectedPatient(undefined);
        break;
    }
  };

  const updateOutPatientCaseDetailsSide = (caseDetails: any) => {
    if (caseDetails.length === 0) {
      setCaseHistoryData([]);
    }
  };

  const updateInPatientCaseDetailsSide = (caseDetails: any) => {
    if (caseDetails.length === 0) {
      setCaseHistoryData([]);
    }
  };

  async function getCaseHistoryList() {
    let params = "";
    const getCaseHistoryResult: any = await CaseHistoryService.getCaseHistory(
      params,
      searchText
    );
    if (getCaseHistoryResult.isSuccess) {
      setCaseHistoryListData(getCaseHistoryResult.result);
      updateCaseList();
    } else {
      console.log("error");
    }
  }

  const updateCaseList = () => {
    getPatientHistoryList("active");
    const inPatientStatus = location?.state?.inPatient;
    if (inPatientStatus) {
      onInPatientBtnClicked();
    }
  };

  useEffect(() => {
    if (isIpad) {
      setSelectedPatient(undefined);
      setCaseHistorySelection(false);
    }
  }, [isIpad]);

  const handleOnBackClick = () => {
    if (!utilService.isWeb()) {
      for (var i = 0; i < outPatientCaseHistory.length; i++) {
        outPatientCaseHistory.map(
          (outPatientCaseHistory: any, index: any) =>
            (outPatientCaseHistory.isSelected = false)
        );
      }
    }
    setCaseHistorySelection(false);
  };

  const updateCaseHistoryDetail = (ProviderUpdated: any,isInPatient:any) => {
    setTimeout(() => {
      if (ProviderUpdated) {
        setSelectedPatient(undefined);
        setCaseHistorySelection(false);
        let index = CaseHistoryListData.findIndex(
          (historyList: { id: any }) => historyList.id === ProviderUpdated
        );

        if (isInPatient) {
          setInPatientBtnClicked(true);
          setOutPatientBtnClicked(false);
        } else{
          setOutPatientBtnClicked(true);
          setInPatientBtnClicked(false);
        }
      }
      getPatientHistoryList("active");
    }, 100);
  };

  const updateDetailsPage =async (ProviderUpdated: any,isInPatient:any) => {
    const updatedOutPatient = outPatientCaseHistory?.find((patient:any)=>patient?.id ===ProviderUpdated)
    const updatedInPatient = inPatientCaseHistory?.find((patient:any)=>patient?.id ===ProviderUpdated)
    setTimeout(() => {
      if (ProviderUpdated) {
        setSelectedPatient(ProviderUpdated);
        let index = CaseHistoryListData.findIndex(
          (historyList: { id: any }) => historyList.id === ProviderUpdated
        );
        if (isInPatient) {
          handleInPatientCaseHistoryCardSelection(updatedInPatient);
          setSelectedPatient(updatedInPatient);
          setInPatientBtnClicked(true);
          setOutPatientBtnClicked(false);
        } else{
          handleOutPatientCaseHistoryCardSelection(updatedOutPatient);
          setSelectedPatient(updatedOutPatient);
          setOutPatientBtnClicked(true);
          setInPatientBtnClicked(false);
        }
      }
      getPatientHistoryList("active");
    }, 100);
  };

  const onInPatientBtnClicked = () => {
    setOutPatientBtnClicked(false);
    setInPatientBtnClicked(true);
    const sentBtn = document.getElementById("file-share-sent-button");
    const receivedBtn = document.getElementById("file-share-received-button");
    sentBtn?.style.setProperty("border-bottom", "solid 2px deepskyblue");
    receivedBtn?.style.setProperty("border-bottom", "none");
  };

  const onOutPatientBtnClicked = () => {
    setOutPatientBtnClicked(true);
    setSelectedPatient(undefined);
    setInPatientBtnClicked(false);
    const sentBtn = document.getElementById("file-share-sent-button");
    const receivedBtn = document.getElementById("file-share-received-button");
    receivedBtn?.style.setProperty("border-bottom", "solid 2px deepskyblue");
    sentBtn?.style.setProperty("border-bottom", "none");
  };

  return (
    <div
      className={`case-history-container ${
        props.isFromEMTHome ? "case-history-emt-home" : ""
      }`}
    >
      <IonRow>
        <IonCol
          size-lg="4"
          size="12"
          className={`${isCaseHistorySelected ? "hide-section" : ""}`}
        >
          <div className="user-chat-component-container">
            <div className="user-chat-container">
              {utilService.isWeb() === false && (
                <div
                  className="start-a-case-button-container"
                  hidden={!isEMTUser}
                >
                  <div className="box">
                    <Link
                      to={{
                        pathname: `/client/emt-patient-form`,
                      }}
                    >
                      <div className="start-a-case-button">
                        {" "}
                        <IonIcon slot="start" icon={addCircle} />
                      </div>
                    </Link>
                  </div>
                </div>
              )}

              <div className="file-share-select-user-header case-history-header">
                <div className="ems-header-label">{t("caseHistory")}</div>
              </div>
              <div className="case-history-list">
                <div className="searchbar-containar-item">
                  <IonSearchbar
                    debounce={1000}
                    value={searchText}
                    // disabled={isShowPopOver}
                    onIonChange={(e) => {
                      setSearchText(e.detail.value!);
                    }}
                    onIonClear={(e) => {
                      setSearchText("");
                      // setPageNo(1);
                    }}
                   placeholder={t("searchByCaseType")}
                    type="search"
                    autocomplete="off"
                    autoCorrect="off"
                    className="searchbar"
                  ></IonSearchbar>
                </div>
              </div>
              <div className="ems-dropdown-div">
                <SortByEMSDropDown
                  getSelectedItem={getFilteredId}
                  hideLabel={false}
                  caseUpdated={caseUpdates}
                ></SortByEMSDropDown>
              </div>
              <div className="ems-patient-tabs-wrapper">
                <div
                  className={`file-share-tabs-container ${
                    !utilService.isWeb() &&
                    "file-share-tabs-container-small-screen"
                  }`}
                  hidden={isEMTUser}
                >
                  <div
                    className="file-share-sent-button"
                    id="file-share-sent-button"
                    onClick={onInPatientBtnClicked}
                  >
                    {t("inpatient")}
                  </div>
                  <div
                    className="file-share-received-button"
                    id="file-share-received-button"
                    onClick={onOutPatientBtnClicked}
                  >
                   {t("outpatient")}
                  </div>
                </div>
              </div>

              <div className="ems-patient-list-container">
                {outPatientBtnClicked && (
                  <IonGrid className="ems-patient-history-grid ">
                    <IonCol className="base-column" size="12" size-lg="4">
                      {!_.isEmpty(outPatientCaseHistory) ? (
                        outPatientCaseHistory.map(
                          (outPatientCaseHistory: any, index: any) => (
                            <CaseHistoryMessageListCard
                              listData={outPatientCaseHistory}
                              key={outPatientCaseHistory.id}
                              index={index}
                              getSelectedCaseHistoryCard={
                                handleOutPatientCaseHistoryCardSelection
                              }
                            />
                          )
                        )
                      ) : (
                        <div className="no-results-label">
                         {t("noCasesFound")}
                        </div>
                      )}
                    </IonCol>
                  </IonGrid>
                )}

                {inPatientBtnClicked && (
                  <IonGrid className="ems-patient-history-grid ">
                    <IonCol className="base-column" size="12" size-lg="4">
                      {!_.isEmpty(inPatientCaseHistory) ? (
                        inPatientCaseHistory.map(
                          (inPatientCaseHistory: any, index: any) => (
                            <CaseHistoryMessageListCard
                              listData={inPatientCaseHistory}
                              key={inPatientCaseHistory.id}
                              index={index}
                              getSelectedCaseHistoryCard={
                                handleInPatientCaseHistoryCardSelection
                              }
                            />
                          )
                        )
                      ) : (
                        <div className="no-results-label">
                        {t("noCasesFound")}
                        </div>
                      )}
                    </IonCol>
                  </IonGrid>
                )}
              </div>
            </div>
          </div>
        </IonCol>
        <IonCol
          size-lg="8"
          size="12"
          className={`${
            !isCaseHistorySelected && !utilService.isWeb() ? "hide-section" : ""
          }`}
        >
          {showLoader && (
            <div className="loader-container">
              <Loader></Loader>
            </div>
          )}

          {utilService.isWeb() && (
            <div className="start-a-case-button-container" hidden={!isEMTUser}>
              <div className="box">
                <Link
                  to={{
                    pathname: `/client/emt-patient-form`,
                  }}
                 title={t("startCase")}
                >
                  <div className="start-a-case-button">
                    {" "}
                    <IonIcon slot="start" icon={addCircle} />
                  </div>
                </Link>
              </div>
            </div>
          )}
          <div className="user-chat-message-details-container case-history-details-full-height">
            <div className="user-chat-message-options-footer casehistory-detail-header">
              {!utilService.isWeb() && (
                <>
                  <div
                    className="back-icon case-history-back"
                    onClick={() => {
                      handleOnBackClick();
                    }}
                  >
                    <IonIcon icon={chevronBackOutline} />
                  </div>
                </>
              )}
            </div>

            <div className="user-chat-message-details-wrapper case-history-details-full-height case-details-wrapper">
              {isLoaderActive && (
                <div className="loader-container">
                  <Loader></Loader>
                </div>
              )}
              <div>
                {!_.isEmpty(caseHistoryData) ? (
                  <CaseHistoryDetailsView
                    key={caseHistoryData.id}
                    listData={caseHistoryData}
                    index={caseHistoryData.id}
                    selectedMessageCardDetails={caseHistoryData}
                    updateDetailsPage={updateDetailsPage}
                    updateCaseHistoryDetail={updateCaseHistoryDetail}
                    triggerPatientList={triggerPatientList}
                    fetchedcaseHistoryData={fetchedcaseHistoryData}
                  />
                ) : (
                  [
                    !isLoaderActive && (
                      <div className="no-results-label" key={""}>
                     {t("noCaseHistoryDetails")}
                      </div>
                    ),
                  ]
                )}
              </div>
            </div>
          </div>
        </IonCol>
      </IonRow>
    </div>
  );
};

export default CaseHistoryComponent;
